



















import axios from "@/libs/axios";
import useBirdEmbeddedSignup from "@/composables/v3/useBirdEmbeddedSignup";
import { BButton, BSpinner } from "bootstrap-vue";
import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";
import { useCustomersStore } from "@/store/useCustomersStore";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";

export default defineComponent({
    components: { BButton, BSpinner },
    setup() {
        const initialDisabled = ref(true);
        const whatsappChannels = ref(null);
        const { launchWhatsAppSignup, isSignupInProgress, isSetupInProgress, initMetaSdk } = useBirdEmbeddedSignup();

        onMounted(() => {
            initMetaSdk();
        });

        const fetchWhatsappChannels = () => {
            return axios
                .get("channels", {
                    params: {
                        fields: "name,provider,platform,identity,active",
                        s: {
                            $or: [{ platform: { $cont: "whatsapp" } }, { provider: { $cont: "bird" } }],
                        },
                    },
                })
                .then((res) => {
                    whatsappChannels.value = res.data;

                    initialDisabled.value = false;
                });
        };
        fetchWhatsappChannels();

        const hasReachedLimit = computed(() => {
            const { customerSettings } = storeToRefs(useCustomersStore());

            const channels = whatsappChannels.value?.filter(
                (channel) => channel.provider === "bird" && channel.platform === "whatsapp"
            );

            return channels?.length >= customerSettings.value.birdEmbeddedSignupLimit;
        });

        const hasEnvConfiguration = () => {
            return !!(
                process.env.VUE_APP_META_APP_ID &&
                process.env.VUE_APP_META_APP_SECRET &&
                process.env.VUE_APP_META_CONFIG_ID
            );
        };

        const isButtonDisabled = computed(() => {
            return (
                isSignupInProgress.value || isSetupInProgress.value || hasReachedLimit.value || !hasEnvConfiguration()
            );
        });

        const toast = useToast();
        const openPopup = async () => {
            launchWhatsAppSignup((err) => {
                if (err) {
                    toast.error(typeof err === "string" ? err : i18n.t("embedded-signup.failed"));
                    return;
                }

                toast.success(i18n.t("embedded-signup.success"));
            });
        };

        const buttonTitle = computed(() => {
            if (!hasEnvConfiguration()) {
                return "No valid configuration found for embedded signup. Please contact Saysimple.";
            }

            if (hasReachedLimit.value) {
                return i18n.t("embedded-signup.limit-reached");
            }
        });

        return {
            buttonTitle,
            hasReachedLimit,
            initialDisabled,
            isButtonDisabled,
            isSetupInProgress,
            isSignupInProgress,
            openPopup,
        };
    },
});
